import React, {useEffect, useState} from 'react';
import {Button, Col, Row} from 'antd';
import {RealtimeGetMethod} from '../common/ApiMethod';
import {Arguments} from '../common/Arguments';
import {handleExport} from '../common/ExportDataToExcelComponent';

const Employees = () => {
	const getApi = Arguments.host + '/society_organization/society/api!employeeInformation.do';
	const employeeApi = Arguments.host + '/society_organization/home/api!organizationAndEmployee.do';
	const [data, setData] = useState([]);

	useEffect(() => {
		RealtimeGetMethod(employeeApi).then(allData => setData(allData));
	}, [getApi]);

	const exportMethod = () => {
		RealtimeGetMethod(employeeApi).then(allData => {
			const filteredData = allData?.map(
				(
					{
						organization_name,
						people_name,
						people_sex,
						people_born,
						people_zzmm,
						people_education,
						mbsk_post,
						people_unit,
						people_post,
						people_professional,
					},
				) =>
					(
						{
							'组织名称': organization_name,
							'姓名': people_name,
							'性别': people_sex,
							'出生日期': people_born,
							'政治面貌': people_zzmm,
							'学历': people_education,
							'社团职务': mbsk_post,
							'工作单位': people_unit,
							'职务': people_post,
							'职称': people_professional,
						}
					),
			);
			handleExport(filteredData);
		});
	};

	return (
		<Row>
			<Col span={3} style={{
				textAlign: 'right',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'flex-end',
				marginBottom: 15,
			}}>民非从业人员：</Col>
			<Col span={1} style={{
				textAlign: 'left',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'flex-end',
				marginBottom: 15,
			}}>{data?.length}</Col>
			<Col span={20} style={{textAlign: 'left'}}>
				<Button type="link" style={{marginBottom: 15}} onClick={() => exportMethod()}>【导出】</Button>
			</Col>
		</Row>
	);
};

export default Employees;
